import { render } from "./MainSection.vue?vue&type=template&id=8263bd96&scoped=true"
import script from "./MainSection.vue?vue&type=script&lang=js"
export * from "./MainSection.vue?vue&type=script&lang=js"

import "./MainSection.vue?vue&type=style&index=0&id=8263bd96&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-8263bd96"

export default script